export const COOKIE_CATEGORY = {
  STRICTLY_NECESSARY: 'strict',
  PERFORMANCE: 'performance',
  FUNCTIONAL: 'functionality',
  TARGETING: 'targeting',
  UNCLASSIFIED: 'unclassified'
}

export const COOKIE_CATEGORY_TITLE_BY_COOKIE_CATEGORY = {
  [COOKIE_CATEGORY.STRICTLY_NECESSARY]: 'Strictly Necessary',
  [COOKIE_CATEGORY.PERFORMANCE]: 'Performance',
  [COOKIE_CATEGORY.FUNCTIONAL]: 'Functional',
  [COOKIE_CATEGORY.TARGETING]: 'Targeting',
  [COOKIE_CATEGORY.UNCLASSIFIED]: 'Unclassified'
}

export const MAIN_COOKIE_CATEGORY_VALUES = [
  COOKIE_CATEGORY.STRICTLY_NECESSARY,
  COOKIE_CATEGORY.PERFORMANCE,
  COOKIE_CATEGORY.FUNCTIONAL,
  COOKIE_CATEGORY.TARGETING,
  COOKIE_CATEGORY.UNCLASSIFIED
]

export const COOKIE_ENTITY_TYPE = {
  DFP_BANNER: 'DFP_BANNER',
  INTERSTITIAL_BANNER: 'INTERSTITIAL_BANNER',
  VIDEO_BANNER: 'VIDEO_BANNER',
  DISQUS: 'DISQUS',
  RE_CAPTCHA: 'RE_CAPTCHA',
  YOUTUBE: 'YOUTUBE',
  ONE_SIGNAL: 'ONE_SIGNAL',
  BLUE_SNAP: 'BLUE_SNAP',
  TWITTER_CARD: 'TWITTER_CARD',
  ROBOTS_ROTATION: 'ROBOTS_ROTATION',
  FACEBOOK: 'FACEBOOK',
  GOOGLE_ANALYTICS: 'GOOGLE_ANALYTICS',
  CLARITY: 'CLARITY',
  BUZZ_SPROUT: 'BUZZ_SPROUT',

  /**
   * For unknown entities it's safe to assume that consent
   * to ALL cookie categories is required
   *
   * # Example: dynamic scripts/iframes fetched from BE (article body)
   */
  UNKNOWN: 'UNKNOWN'
}

const DFP_BANNER_REQUIRED_COOKIE_CATEGORIES = [
  COOKIE_CATEGORY.TARGETING,
  COOKIE_CATEGORY.UNCLASSIFIED
]

/**
 * Full list of prior blocked services
 */
export const REQUIRED_COOKIE_CATEGORIES_BY_COOKIE_ENTITY_TYPE = {
  [COOKIE_ENTITY_TYPE.DFP_BANNER]: DFP_BANNER_REQUIRED_COOKIE_CATEGORIES,
  [COOKIE_ENTITY_TYPE.INTERSTITIAL_BANNER]: DFP_BANNER_REQUIRED_COOKIE_CATEGORIES,
  [COOKIE_ENTITY_TYPE.VIDEO_BANNER]: [COOKIE_CATEGORY.TARGETING],
  [COOKIE_ENTITY_TYPE.DISQUS]: [
    COOKIE_CATEGORY.FUNCTIONAL,
    COOKIE_CATEGORY.TARGETING,
    COOKIE_CATEGORY.PERFORMANCE,
    COOKIE_CATEGORY.UNCLASSIFIED
  ],
  [COOKIE_ENTITY_TYPE.RE_CAPTCHA]: [
    COOKIE_CATEGORY.FUNCTIONAL,
    COOKIE_CATEGORY.TARGETING,
    COOKIE_CATEGORY.UNCLASSIFIED
  ],
  [COOKIE_ENTITY_TYPE.YOUTUBE]: [
    COOKIE_CATEGORY.FUNCTIONAL,
    COOKIE_CATEGORY.TARGETING,
    COOKIE_CATEGORY.UNCLASSIFIED
  ],
  [COOKIE_ENTITY_TYPE.ONE_SIGNAL]: [
    COOKIE_CATEGORY.FUNCTIONAL,
    COOKIE_CATEGORY.PERFORMANCE,
    COOKIE_CATEGORY.TARGETING,
    COOKIE_CATEGORY.UNCLASSIFIED
  ],
  [COOKIE_ENTITY_TYPE.BLUE_SNAP]: [
    COOKIE_CATEGORY.FUNCTIONAL,
    COOKIE_CATEGORY.TARGETING,
    COOKIE_CATEGORY.PERFORMANCE,
    COOKIE_CATEGORY.UNCLASSIFIED
  ],
  [COOKIE_ENTITY_TYPE.TWITTER_CARD]: MAIN_COOKIE_CATEGORY_VALUES,
  [COOKIE_ENTITY_TYPE.ROBOTS_ROTATION]: [
    COOKIE_CATEGORY.FUNCTIONAL,
    COOKIE_CATEGORY.UNCLASSIFIED
  ],
  [COOKIE_ENTITY_TYPE.FACEBOOK]: MAIN_COOKIE_CATEGORY_VALUES,
  [COOKIE_ENTITY_TYPE.GOOGLE_ANALYTICS]: [
    COOKIE_CATEGORY.PERFORMANCE,
    COOKIE_CATEGORY.UNCLASSIFIED
  ],
  [COOKIE_ENTITY_TYPE.CLARITY]: [
    COOKIE_CATEGORY.PERFORMANCE,
    COOKIE_CATEGORY.UNCLASSIFIED
  ],
  [COOKIE_ENTITY_TYPE.BUZZ_SPROUT]: [
    COOKIE_CATEGORY.TARGETING,
    COOKIE_CATEGORY.FUNCTIONAL,
    COOKIE_CATEGORY.UNCLASSIFIED
  ],
  [COOKIE_ENTITY_TYPE.UNKNOWN]: MAIN_COOKIE_CATEGORY_VALUES
}

export const CMP_CONSENT_COOKIE_NAME = 'CookieScriptConsent'

export const HANDLER_TYPE = {
  GLOBAL: 'global',
  LOCAL: 'local'
}

export const HANDLER_TYPE_BY_ENTITY_TYPE = {
  [COOKIE_ENTITY_TYPE.DFP_BANNER]: HANDLER_TYPE.GLOBAL,
  [COOKIE_ENTITY_TYPE.INTERSTITIAL_BANNER]: HANDLER_TYPE.LOCAL,
  [COOKIE_ENTITY_TYPE.VIDEO_BANNER]: HANDLER_TYPE.LOCAL,
  [COOKIE_ENTITY_TYPE.DISQUS]: HANDLER_TYPE.LOCAL,
  [COOKIE_ENTITY_TYPE.RE_CAPTCHA]: HANDLER_TYPE.GLOBAL,
  [COOKIE_ENTITY_TYPE.YOUTUBE]: HANDLER_TYPE.LOCAL,
  [COOKIE_ENTITY_TYPE.ONE_SIGNAL]: HANDLER_TYPE.GLOBAL,
  [COOKIE_ENTITY_TYPE.BLUE_SNAP]: HANDLER_TYPE.LOCAL,
  [COOKIE_ENTITY_TYPE.TWITTER_CARD]: HANDLER_TYPE.LOCAL,
  [COOKIE_ENTITY_TYPE.FACEBOOK]: HANDLER_TYPE.LOCAL,
  [COOKIE_ENTITY_TYPE.GOOGLE_ANALYTICS]: HANDLER_TYPE.GLOBAL,
  [COOKIE_ENTITY_TYPE.CLARITY]: HANDLER_TYPE.LOCAL,
  [COOKIE_ENTITY_TYPE.BUZZ_SPROUT]: HANDLER_TYPE.LOCAL,
  [COOKIE_ENTITY_TYPE.UNKNOWN]: HANDLER_TYPE.LOCAL
}

export const CMP_POPUP_WRAPPER_ID = 'cookiescript_injected_wrapper'

export const CMP_STATE = {
  CA: 'ca'
}

export const CMP_CCPA_CONTACT_US_LINK_TEXT =
  'Do Not Sell or Share My Personal Information'
